import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { QuotationInfoContext } from "../../contexts";
import { Confirmation } from "../../../../../../../shared/components";

export const ConfirmIssueRenewal = () => {
  const navigate = useNavigate();

  const { quotationInfo } = useContext(QuotationInfoContext);

  const onPressConfirm = () => navigate('/produccion/listado-de-polizas');

  return (
    <Confirmation
      title={`Renovacion ${quotationInfo?.token} enviada correctamente`}
      description={`Se ha renovado correctamente la póliza`}
      onPressConfirm={onPressConfirm}
    />
  );
};
